module.exports = __webpack_public_path__ + "img/foto_3.d286b919.jpg";